module.exports = __webpack_public_path__ + "static/media/selfie.9d35da24.png";